// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-meet-3d-link-card .copy-url-clipboard,\n.ui-meet-3d-link-card .copy-url-clipboard:hover {\n  background: none;\n}\n.ui-meet-3d-link-card .qr-code-button {\n  background: none;\n  margin-top: -2.5em;\n  margin-left: -1em !important;\n}\n.ui-meet-3d-link-card .qr-code-button:hover,\n.ui-meet-3d-link-card .qr-code-button:active {\n  background: none;\n}\n", ""]);
// Exports
module.exports = exports;
